import getHelper from '../../../services/getHelper';

export default getHelper('/training-programs/:id', {
  eligibility: getHelper('/eligibility/:id'),
});
